import $http from "@/services/Http";
import { prefix } from "@/api/config";
import { responseToClass } from "@/api/lib";
import User from "@/models/User";
import { AxiosPromise } from "axios";
import InviteFormRequest from "@/forms/requests/user/InviteFormRequest";

export function list(
  teamId: string,
  $projectIsSmart?: boolean
): AxiosPromise<User[]> {
  const params: Record<string, any> = {};

  if ($projectIsSmart !== undefined) {
    params.is_smart = $projectIsSmart;
  }

  return $http
    .get(`${prefix}/teams/${teamId}/users`, { params })
    .then((response) => responseToClass(User, response));
}

export function searchAvailable(
  teamId: string,
  query: string
): AxiosPromise<User[]> {
  return $http
    .get(`${prefix}/teams/${teamId}/users-available`, {
      params: {
        query,
      },
    })
    .then((response) => responseToClass(User, response));
}

export function attach(
  teamId: string,
  userId: string,
  data = {}
): AxiosPromise<User> {
  return $http
    .put(`${prefix}/teams/${teamId}/users/${userId}`, data)
    .then((response) => responseToClass(User, response));
}

export function promoteToMainTeam(
  teamId: string,
  userId: string,
  data = {}
): AxiosPromise<User> {
  return $http
    .put(`${prefix}/teams/${teamId}/users/${userId}/promote-main-team`, data)
    .then((response) => responseToClass(User, response));
}

export function detach(teamId: number, userId: number) {
  return $http.delete(`${prefix}/teams/${teamId}/users/${userId}`);
}

export function inviteByEmail(
  teamId: string,
  email: string,
  data: InviteFormRequest
): AxiosPromise<User> {
  return $http
    .post(`${prefix}/teams/${teamId}/users`, { email, ...data })
    .then((response) => responseToClass(User, response));
}
